import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const router = [
  {
    path: `/${RouteGroup.TRANSFORMATIONHUB}`,
    component: () =>
      import(/* webpackChunkName: "transformationhub-page" */ './pages/TransformationhubPage.vue'),
    props: true,
  },
  {
    path: `/${RouteGroup.TRANSFORMATIONHUB_ASSISTANT}/:name`,
    name: 'Transformationhub_assistant',
    component: () =>
      import(
        /* webpackChunkName: "transformationhub-assistant-page" */ './pages/TransformationhubAssistantPage.vue'
      ),
    props: true,
  },
];
